import { render } from "./NavTabs.vue?vue&type=template&id=fe0b37d6&ts=true"
import script from "./NavTabs.vue?vue&type=script&lang=ts"
export * from "./NavTabs.vue?vue&type=script&lang=ts"

import "./NavTabs.vue?vue&type=style&index=0&id=fe0b37d6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__